import { useEntity } from '@backstage/plugin-catalog-react';
import { Box, Button, Card, CardContent, Typography } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';

const TEMPLATE_NAME = 'dependency-updates';
const TEMPLATE_NAMESPACE = 'default';

export const DependencyUpdateTab = () => {
  const { entity } = useEntity();
  const navigate = useNavigate();

  const annotations = entity.metadata.annotations ?? {};
  const repoName = annotations['dna.dev.wsa.com/source_repo'] ?? entity.metadata.name;
  const projectName = annotations['dna.dev.wsa.com/source_project'] ?? 'SW';

  const handleOnboardDependency = () => {
    const params = new URLSearchParams({
      formData: JSON.stringify({
        orgName: 'WSAudiology',
        projectName,
        repoName,
      }),
    });
    navigate(`/create/templates/${TEMPLATE_NAMESPACE}/${TEMPLATE_NAME}?${params.toString()}`);
  };

  return (
    <Box>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Dependency Update
          </Typography>
          <Typography variant="body1" paragraph>
            Click the button below to register automated dependency updates for <strong>{repoName}</strong>.
          </Typography>
          <Typography variant="body2" color="textSecondary" paragraph>
            This will launch the dependency update template and run the associated pipeline to create a Pull Request
            enabling Renovate for your repository.
          </Typography>

          <Box mt={2}>
            <Button variant="contained" color="primary" onClick={handleOnboardDependency} size="large">
              Register
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
